/**
 * Created by Omar Alejandro Leonor Avalos on 2017-06-06.
 * Exporting all services.
 * This folder is apart from the others because more than one
 * container can use multiple services.
 */
import * as users from './users';
import * as despachos from './despachos';
import * as customers from './customers';
import * as suppliers from './suppliers';
import * as customsHouses from './customsHouses';
import * as statuses from './statuses';
import * as invoiceItems from './invoiceItems';
import * as preInvoice from './preInvoice';
import * as customerTabularPriceses from './customerTabularPriceses';
import * as expensesTabularPriceses from './expensesTabularPriceses';
import * as test from './test'; //only for testing
import * as reports from './reports';

export {
    users,
    despachos,
    customers,
    suppliers,
    customsHouses,
    statuses,
    invoiceItems,
    preInvoice,
    customerTabularPriceses,
    expensesTabularPriceses,
    test,
    reports
};



// WEBPACK FOOTER //
// ./services/index.js